import { render, staticRenderFns } from "./buildTypeDiagram.vue?vue&type=template&id=fa53dae8&scoped=true"
import script from "./buildTypeDiagram.vue?vue&type=script&lang=js"
export * from "./buildTypeDiagram.vue?vue&type=script&lang=js"
import style0 from "./buildTypeDiagram.vue?vue&type=style&index=0&id=fa53dae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa53dae8",
  null
  
)

export default component.exports